import { Permisos } from './../../../models/permisos.model';
import { Component, ViewChild, TemplateRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog, MatDatepickerInputEvent } from '@angular/material';
declare var jQuery: any;
declare var $: any;

@Component({
    selector: "page-permisos",
    templateUrl: "./permisos.component.html",
    styleUrls: ["./permisos.component.css"],
    providers: [FormService]
})

export class PermisosComponent {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

    public rows = [];
    public actualRow;
    public permiso: Permisos;
    public form;
    public temp_perm;

    public fecha_perm;
    public resol_fecha;
    public prim_fecha;
    public recep_fecha;

    public maxDate;
    public n_form;
    public matcher = new FormService();

    constructor(private fb: FormBuilder, private dialog: MatDialog) {
        this.maxDate = moment().toDate()

        if (!JSON.parse(localStorage.getItem("Permisos"))) {
            localStorage.setItem("Permisos", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("Permisos"));
        }
        this.permiso = { perm_numero: 0, perm_fecha: null, superfm2: 0, modproy: 'false', resolucion: 0, fecha_resol: null, perm_prim: 0, fecha_prim: null, recepcion: 0, fecha_recep: null, recordId: '' };
        this.temp_perm = { perm_numero: 0, perm_fecha: null, superfm2: 0, modproy: 'false', resolucion: 0, fecha_resol: null, perm_prim: 0, fecha_prim: null, recepcion: 0, fecha_recep: null, recordId: '' };

        this.form = new FormGroup({
            perm_numero: new FormControl('', [Validators.required, Validators.min(0),Validators.pattern(/[0-9]*/)]),
            perm_fecha: new FormControl({ value: '', disabled: true }, Validators.required),
            superfm2: new FormControl('', [Validators.required, Validators.min(0),Validators.pattern(/[0-9]*/)]),
            modproy: new FormControl(''),
            resolucion: new FormControl(''),
            fecha_resol: new FormControl({ value: '', disabled: true }),
            perm_prim: new FormControl(''),
            fecha_prim: new FormControl({ value: '', disabled: true }),
            recepcion: new FormControl(''),
            fecha_recep: new FormControl({ value: '', disabled: true })
        })
        this.n_form = localStorage.getItem('form');
        console.log("Formulario seleccionado", this.n_form)
        this.form.controls['perm_fecha'].setValue(this.rows[0] ? new Date(this.rows[0].perm_fecha) : null)
        this.form.controls['fecha_resol'].setValue(this.rows[0] ? new Date(this.rows[0].fecha_resol) : null)
        this.form.controls['fecha_prim'].setValue(this.rows[0] ? new Date(this.rows[0].fecha_prim) : null)
        this.form.controls['fecha_recep'].setValue(this.rows[0] ? new Date(this.rows[0].fecha_recep) : null)
        this.form.controls['perm_numero'].setValue(this.rows[0] ? this.rows[0].perm_numero : '')
        this.form.controls['superfm2'].setValue(this.rows[0] ? this.rows[0].superfm2 : '')
        this.form.controls['resolucion'].setValue(this.rows[0] ? this.rows[0].resolucion : '')
        this.form.controls['perm_prim'].setValue(this.rows[0] ? this.rows[0].perm_prim : '')
        this.form.controls['recepcion'].setValue(this.rows[0] ? this.rows[0].recepcion : '')
        this.form.controls['modproy'].setValue(this.rows[0] ? this.rows[0].modproy : false);


    }

    add_Permisos() {


        if (this.form.get('perm_fecha').value) {
            this.fecha_perm = moment(this.form.get('perm_fecha').value).format('DD/MM/YYYY')
        }
        else {
            this.fecha_perm = '';
        }
        if (this.form.get('fecha_resol').value) {
            this.resol_fecha = moment(this.form.get('fecha_resol').value).format('DD/MM/YYYY')
        }
        else {
            this.resol_fecha = '';
        }
        if (this.form.get('fecha_prim').value) {
            this.prim_fecha = moment(this.form.get('fecha_prim').value).format('DD/MM/YYYY')
        }
        else {
            this.prim_fecha = '';
        }
        if (this.form.get('fecha_recep').value) {
            this.recep_fecha = moment(this.form.get('fecha_recep').value).format('DD/MM/YYYY')
        }
        else {
            this.recep_fecha = '';
        }

        this.actualRow = localStorage.getItem("Permisos");
        this.rows = JSON.parse(this.actualRow);

        if ((!this.form.value.perm_numero || !this.form.fecha_perm) && !this.form.value.superfm2 && !this.form.value.modproy && !this.form.value.resolucion
            && !this.form.resol_fecha && !this.form.value.perm_prim && !this.prim_fecha && !this.form.value.recepcion && !this.recep_fecha) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);
        } else {
            this.rows = this.rows.concat({
                perm_numero: this.form.value.perm_numero,
                perm_fecha: this.fecha_perm,
                superfm2: this.form.value.superfm2,
                modproy: this.form.value.modproy,
                resolucion: this.form.value.resolucion,
                fecha_resol: this.resol_fecha,
                perm_prim: this.form.value.perm_prim,
                fecha_prim: this.prim_fecha,
                recepcion: this.form.value.recepcion,
                fecha_recep: this.recep_fecha
            })
            localStorage.setItem("Permisos", JSON.stringify(this.rows));
            this.form.reset();
        }

    }

    delete_Permisos(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                console.log(id)
                console.log(x)
                console.log(this.rows)
                this.rows.splice(x, 1);
                console.log(this.rows)
                localStorage.setItem("Permisos", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("Permisos");
        this.rows = JSON.parse(this.actualRow);
    }

    get_Permisos(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.temp_perm.id = id;
                this.temp_perm.perm_numero = this.rows[x].perm_numero;
                this.temp_perm.perm_fecha = this.rows[x].perm_fecha;
                this.temp_perm.superfm2 = this.rows[x].superfm2;
                this.temp_perm.modproy = this.rows[x].modproy;
                this.temp_perm.resolucion = this.rows[x].resolucion;
                this.temp_perm.fecha_resol = this.rows[x].fecha_resol;
                this.temp_perm.perm_prim = this.rows[x].perm_prim;
                this.temp_perm.fecha_prim = this.rows[x].fecha_prim;
                this.temp_perm.recepcion = this.rows[x].recepcion;
                this.temp_perm.fecha_recep = this.rows[x].fecha_recep;
                this.dialog.open(this.openModal);
            }
        }
    }

    cleanData() {
        this.temp_perm = { perm_numero: 0, perm_fecha: null, superfm2: 0, modproy: '', resolucion: 0, fecha_resol: null, perm_prim: 0, fecha_prim: null, recepcion: 0, fecha_recep: null, recordId: '' };
    }

    save_Permisos() {
        var id = this.temp_perm.id;
        console.log(this.temp_perm)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("Permisos", JSON.stringify(this.rows));
                $("#permisos").modal("hide");
                this.actualRow = localStorage.getItem("Permisos");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    perm_numero: this.temp_perm.perm_numero,
                    perm_fecha: this.temp_perm.perm_fecha,
                    superfm2: this.temp_perm.superfm2,
                    modproy: this.temp_perm.modproy,
                    resolucion: this.temp_perm.resolucion,
                    fecha_resol: this.temp_perm.fecha_resol,
                    perm_prim: this.temp_perm.perm_prim,
                    fecha_prim: this.temp_perm.fecha_prim,
                    recepcion: this.temp_perm.recepcion,
                    fecha_recep: this.temp_perm.fecha_recep,
                    recordId: this.temp_perm.recordId,

                })
                console.log(this.temp_perm.modproy)
                localStorage.setItem("Permisos", JSON.stringify(this.rows));
                // this.temp_perm = {perm_numero:0, perm_fecha:null, superfm2:0, modproy:'', resolucion:0, fecha_resol:null, perm_prim:0, fecha_prim:null, recepcion:0, fecha_recep:null,recordId:'' };
                this.temp_perm = [];
                this.dialog.closeAll();
            }
        }
    }
}